export async function changecolorinit() {
    let colors = ["rgb(34, 73, 102)", "rgb(186, 185, 179)", "rgb(201, 211, 172)", "rgb(241, 211, 198)", "rgb(225, 243, 231)", "rgb(244, 244, 244)"]
    let nowColor = -1
    let ramdomColor

    try {
        nowColor = colors.indexOf(document.body.style.backgroundColor)
    } catch (error) {
        console.log(error)
    }

    do {
        ramdomColor = Math.floor(Math.random() * colors.length)
    } while (nowColor == ramdomColor);

    document.body.style.backgroundColor = colors[ramdomColor]
    document.querySelector(".header__innerNav").style.background = colors[ramdomColor]

    document.body.classList.remove("white")
    document.body.classList.remove("bgwhite")
    if (ramdomColor == 0) {
        document.body.classList.add("white")
    } else if (ramdomColor == 5) {
        document.body.classList.add("bgwhite")
    }
}

export async function changetopsvg() {
    if (location.pathname == "/") {
        let pcsvgs = document.querySelector(".home>.bg>.pc").children
        let spsvgs = document.querySelector(".home>.bg>.sp").children

        let rndsvg = Math.floor(Math.random() * pcsvgs.length)

        Array.prototype.forEach.call(pcsvgs, (svg, i) => {
            svg.style.display = "none"
            if (i == rndsvg) {
                svg.style.display = "block"
            }
        })
        Array.prototype.forEach.call(spsvgs, (svg, i) => {
            svg.style.display = "none"
            if (i == rndsvg) {
                svg.style.display = "block"
            }
        })
    }
}

window.globalColorInit = () => {
    changecolorinit()
}